import { render, staticRenderFns } from "./SystemAssessmentsTab.vue?vue&type=template&id=fedef28e&"
import script from "./SystemAssessmentsTab.vue?vue&type=script&lang=js&"
export * from "./SystemAssessmentsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports